import {Injectable} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Autowired} from '@angular-ru/autowired';
import {BasicRestMetierService} from '@app/core/services/basic-rest-metier.service';
import {Observable} from 'rxjs';
import {IRecupererOptionsMetier} from '@app/core/interfaces/metier/i-recuperer-options-metier';
import {map} from 'rxjs/operators';
import {HttpResponse} from '@angular/common/http';
import {ClvTsUtilsCommonsJs} from 'clv-ts-utils';
import {CommonUtilities} from '@app/core/utilities/common.utilities';
import {IConvertirFormulaireMetier, IInitialiserFormulaireMetier} from '@app/core/interfaces';
import {DatePipe} from '@angular/common';
import { ModaleModifierBordereauRestApiService } from './modale-modifier-bordereau.rest-api.service';

@Injectable({providedIn: 'root'})
export class ModaleModifierBordereauMetierService extends BasicRestMetierService implements IConvertirFormulaireMetier,
    IInitialiserFormulaireMetier,
    IRecupererOptionsMetier {

  @Autowired() datePipe: DatePipe;
  @Autowired() formBuilder: FormBuilder;
  @Autowired() restApi: ModaleModifierBordereauRestApiService;


  convertirFormulaire<T>(formGroup: FormGroup, args?: any): T {
    const v: T | any = ClvTsUtilsCommonsJs.copy(formGroup.value);
    v.permissions = CommonUtilities.convertirArbrePermissionEnListeDeChainesDeCaracteres(v.permissions);
    return v;
  }

  initialiserFormulaire<T>(datas: T | any, args?: any): FormGroup {

    const data: any = {
      numeroBordereau: !!datas && !!datas.numeroBordereau ? datas.numeroBordereau : null,
      numeroFacture: !!datas && !!datas.numeroFacture ? datas.numeroFacture : null,
      montantPartAssurance: !!datas && !!datas.montantPartAssurance ? datas.montantPartAssurance : null,
    };

    return this.formBuilder.group({
      numeroBordereau: [{value: data.numeroBordereau, disabled: true}],
      numeroFacture: data.numeroFacture,
      montantPartAssurance: [{value: data.montantPartAssurance, disabled: true}],
    });

  }

  recupererOptions(args?: any): Observable<Array<any>> {
    return this.restApi.requeteRecuperationListeDonnees(null, args)
    .pipe(map((reponse: HttpResponse<Array<any> | any>) => {
      if (!(reponse.body.items && reponse.body.items.length > 0)) {
        return reponse;
      }
      return reponse.body.items;
    }));
  }



  enregistrerModification(data) {
    return this.restApi.enregistrerDonneesBordereau(data)
  }

}
